<template>
    <div :is="$route.params.layout === 'mng' ? 'el-card' : 'slot'">
    
        <article-search :search-params="searchParams" @on-search="searchFormChange" :board-mst="this.boardMst"></article-search>
        <hr class="mt-1"/>
        <el-table
            :data="items"
            :row-class-name="getRowClass"
            stripe
            style="width: 100%"
            @selection-change="handleSelectionChange"
            >
            <el-table-column
            v-if="boardMst.isAdmin"
            align="center"
            type="selection"
            width="55">
            </el-table-column>

            <!-- <el-table-column label="번호" type="index" :index="indexMethod"  width="80"> -->
            <el-table-column label="번호" width="80">
                <template slot-scope="prop">
                    {{ prop.row.index }}
                </template>
            </el-table-column>

            <el-table-column v-if="boardMst.categoryYn === 'Y'" label="분류" width="160">
                <template slot-scope="prop">
                    <span class="text-bold" :class="pickClass('categoryList',prop.row.category)">{{ prop.row.category }}</span>
                </template>
            </el-table-column>

            <el-table-column v-if="boardMst.topNoticeYn == 'Y'" label="" width="40">
                <template slot-scope="prop">
                    <i v-if="prop.row.topNoticeYn == 'Y'" class="el-icon-message-solid text-danger fs20"></i>
                </template>
            </el-table-column>

            <el-table-column label="제목"  >
                <template slot-scope="prop">
                <a :class="prop.row.topNoticeYn == 'Y' ? 'top-notice fs15' : 'text-info2'" @click.prevent="goRead(prop.row)" href="#">{{prop.row.articleTitle}}</a> 
                <i v-if="prop.row.secretYn === 'Y'" class="ml-2 el-icon-lock text-danger font-weight-bold fs16"></i>
                </template>
            </el-table-column>

            <el-table-column label="공지대상"  v-if="boardMst.readRoleAuthYn === 'Y' && boardMst.isAdmin" width="400">
                <template slot-scope="prop">
                    <span class="l-bar fs11" v-for="item in prop.row.roleSeqSet" >
                    {{item | roleNm}}
                    </span>
                </template>
            </el-table-column>

            

            <el-table-column label="작성자" prop="writerNm" width="180">
            </el-table-column>

            <el-table-column v-if="boardMst.writeAuthTy === 'NONE'" label="회원구분" width="100">
                <template slot-scope="prop">
                    
                    {{ prop.row.writerId ? (prop.row.topNoticeYn == 'Y' ? '' :'정회원') : '비회원' }}
                </template>
            </el-table-column>
            
            <el-table-column label="작성일"  width="180">
                <template slot-scope="prop">
                    {{ prop.row.createDt | moment('YYYY.MM.DD HH:mm') }}
                </template>
            </el-table-column>
            <el-table-column v-if="boardMst.stateYn == 'Y'" label="상태" width="140">
                <template slot-scope="prop">
                    <span v-if="prop.row.topNoticeYn !== 'Y'" :class="pickClass('stateList',prop.row.state)">{{ prop.row.state }}</span>
                </template>
            </el-table-column>

        </el-table>
        <el-row type="flex" justify="center" class="mt-4">
            <!-- <p-pagination class="text-center"
                        v-on:input="searchAction"
                        v-model="pagination.currentPage"
                        :total="pagination.totalCount">
            </p-pagination> -->

<!-- 
                        @input.page="searchAction"
                        v-model="pagination.currentPage"
                        :rows="searchParams.rows"
                        :total="pagination.totalCount"
 -->

            <p-pagination class="text-center"
                        v-on:input="searchAction"
                        v-model="pagination.currentPage"
                        :per-page="searchParams.rows"
                        :total="pagination.totalCount">
            </p-pagination>

        </el-row>

        <el-button class="pull-right" @click="editTemplate" v-if="boardMst.isAdmin && boardMst.boardNo == 1"  icon="el-icon-edit">고정글 템플릿 편집</el-button>
        <el-row type="flex" justify="center" class="mt-5">
            <el-button @click="goWrite" v-if="boardMst.canInsert" type="primary" icon="el-icon-edit">글 쓰 기</el-button>

            <el-button @click="deleteArticle" :disabled="checkedRows.length == 0" class="ml-5" v-if="boardMst.isAdmin" type="warning" icon="el-icon-delete">삭 제</el-button>
            <el-button @click="unDeleteArticle" :disabled="checkedRows.length == 0" v-if="boardMst.isAdmin"  icon="el-icon-delete">복 원</el-button>
            <el-button @click="destroy" :disabled="checkedRows.length == 0" v-if="boardMst.isAdmin" type="danger" icon="el-icon-edit">영구삭제</el-button>

        </el-row>



    </div>

</template>

<script>
import Vue from 'vue'
import ArticleSearch from './ArticleSearch.vue'
import PPagination from 'src/components/UIComponents/Pagination.vue'
import BoardProxy from '@/proxies/BoardProxy'
import PasswordModal from './PasswordModal'
import ArticleTemplateEditModal from './ArticleTemplateEditModal.vue'

export default {
    components: {
        ArticleSearch,
        PPagination
    },
    created() {
        this.cleanSearchParams = {...this.searchParams}
        this.searchParams = {...this.cleanSearchParams, ...this.$route.query}

        this.boardNo = this.$route.params.boardNo
        
        this.searchAction(this.searchParams.page || 1)
        .then(() => {
            window.scrollTo(0,this.searchParams.scroll || 0)
        })


    },
    methods: {
        handleSelectionChange( rows ) {
            this.checkedRows = rows
        },
        getRowClass({row, rowIndex}) {

            if(row.deleteYn === 'Y') {
                return 'deleted'
            }

        },
        editTemplate() {

            this.$modal.show(
                ArticleTemplateEditModal,
                { boardNo: this.boardNo, boardNm: this.boardMst.boardNm  },
                { draggable: false, width:'1000px', height: 'auto' },
                { }
            ).result.then(()=> this.$store.dispatch('board/boardMst',this.boardNo ) )



        },
        searchFormChange(searchParams) {
            this.searchParams = {...searchParams}
            this.searchAction(1)
        },
        searchAction(page) {
            
            this.searchParams.page = page
            this.pagination.currentPage = page || 1;

            let query = '?'
            for(const key in this.searchParams) {
                if(this.searchParams[key]) {
                    query += `${key}=${encodeURIComponent(this.searchParams[key])}&`
                }
            }
            this.$router.replace(query)
            
            return new BoardProxy( this.searchParams )
            .getArticleList( this.boardNo )
            .then(res => {
                this.items = [...res.items]
                this.pagination.totalCount = res.totalCount

                this.$store.commit('board/boardMst',res.boardMst)
                this.makeIndex(this.items)

            })

              
        },
        makeIndex( items ) {

            var start = this.pagination.totalCount - ((this.pagination.currentPage-1) * this.searchParams.rows)
            let idx = 0
            items.forEach( item => {
                if('Y' == item.topNoticeYn) {
                    return;
                }
                idx ++
                item.index = start - idx + 1
            })

        },
        indexMethod(index) {
            
            return this.pagination.totalCount - ((this.pagination.currentPage-1) * this.searchParams.rows) - index
            
        },
        pickClass( dest, value ) {

            return (this.boardMst[dest].find(item=>item.value === value) || {}).cls

        },
        saveSearch( obj ) {
        },
        goWrite() {
            if(this.boardMst.canInsert) {
                // saveSearch({...this.searchParams, scroll: window.scrollY})
                console.log({
                        ...this.searchParams, scroll: window.scrollY                         
                    })
                this.$router.push({
                    name : 'ArticleWrite', //`A/board/${this.boardNo}/${row.articleNo}`, 
                    params: {
                        boardNo: this.boardNo
                    },
                    query: {
                        ...this.searchParams, scroll: window.scrollY                         
                    }
                })
                return
            }

        },
        goRead( row ) {

            if(row.canRead) {
                // saveSearch({...this.searchParams, scroll: window.scrollY})
                console.log({
                        ...this.searchParams, scroll: window.scrollY                         
                    })
                this.$router.push({
                    name : 'ArticleView', //`A/board/${this.boardNo}/${row.articleNo}`, 
                    params: {
                        boardNo: this.boardNo,
                        articleNo: row.articleNo,
                    },
                    query: {
                        ...this.searchParams, scroll: window.scrollY                         
                    }
                })
                return
            }

            if(row.writerId && !this.$store.state.account.userName) {
                alert('로그인 후 확인이 가능합니다.')
                this.$router.push('/home')
                return
            }

            this.$modal.show(
                PasswordModal,
                { handler: (password) => {

                    new BoardProxy()
                    .confirmReadPwd( { boardNo: this.boardNo, articleNo: row.articleNo, password } )
                    .then(res=>{
                        if(res.header.returnCode == 'OK' ) {
                            this.$router.push({
                                name : 'ArticleView', //`A/board/${this.boardNo}/${row.articleNo}`, 
                                params: {
                                    boardNo: this.boardNo,
                                    articleNo: row.articleNo,
                                },
                                query: {
                                    ...this.searchParams, scroll: window.scrollY                         
                                }
                            })
                            return
                        }
                        alert(res.header.resultMessages)
                    })

                } },
                { width: '400px' }
            )

            
        },
        getChecked() {

          const checked = []
          this.checkedRows.forEach(item=> checked.push(item.articleNo) )

          return checked

        },
       destroy() {

            if(!confirm('영구삭제된 게시물은 복원할 수 없습니다.\n선택한  게시글을 영구삭제 할까요?')) return

            const checked = this.getChecked()

            new BoardProxy()
            .destroyArticleChecked( this.boardNo, checked )
            .then((res)=>{
                if(res.header.returnCode == 'OK' ) {
                    alert('영구 삭제 되었습니다.')
                    this.searchFormChange(this.cleanSearchParams)
                    return
                }
                alert(res.header.resultMessages)

            })

        },
        unDeleteArticle() {

            if(!confirm('선택한 게시글을 삭제복원 할까요?')) return

            const checked = this.getChecked()
            new BoardProxy()
            .unRemoveArticleChecked( this.boardNo, checked )
            .then((res)=>{
                if(res.header.returnCode == 'OK' ) {
                    alert('복원 되었습니다.')
                    this.searchFormChange(this.searchParams)
                    return
                }
                alert(res.header.resultMessages)

            })
        },
        deleteArticle() {

            if(!confirm('선택한 게시글을 삭제할까요?')) return

            const checked = this.getChecked()
            new BoardProxy()
            .removeArticleChecked( this.boardNo, checked )
            .then((res)=>{
                if(res.header.returnCode == 'OK' ) {
                    alert('삭제 되었습니다.')
                    this.searchFormChange(this.searchParams)
                    return
                }
                alert(res.header.resultMessages)

            })
        },        
    },
    /*
    watch: {
        boardMst( boardMst ) {
            if(boardMst.boardNo && boardMst.boardNo !== this.oldBoardNo) {
               this.searchAction(1)
               this.oldBoardNo = this.boardNo
            }
        }
    },*/
    computed: {
        boardMst() {
            return this.$store.state.board.boardMst
        }
    },
    data() {

        return {
            checkedRows: [],
            searchParams: {
                page: 0,
                scroll: 0,
                rows: 10
                // rows: window.localStorage.getItem('article.rows') || 10,                
            },
            items: [],
            pagination: {
                currentPage: 1,
                totalCount: 0
            },
            index: undefined,
        }
    }

}
</script>

<style>
tr.el-table__row.deleted {text-decoration: line-through;}
.text-bold { font-weight: bold;}
.top-notice { color: black; }
.el-table__row .cell > label.el-checkbox {
    margin: 0;
}

</style>
